import { defineStore } from 'pinia'
import { useState } from '../sort/state'
import Actions from './actions'

export { type SortState } from './state'

export const useSortStore = defineStore('sort', {
  state: useState,
  actions: { ...Actions },
})

export type SortStoreContext = ReturnType<typeof useSortStore>